/** Helpers for API category lists (from GET /category/all). */

export function findCategoryBySlug(categories, slug) {
  if (!slug) return null;
  return (categories || []).find((c) => c.slug === slug) || null;
}

export function getTopLevelCategories(categories) {
  return (categories || []).filter((c) => !c.parentSlug);
}

export function getSubcategories(categories, parentSlug) {
  return (categories || []).filter((c) => c.parentSlug === parentSlug);
}

export function getAllCategorySlugs(categories, parentSlug) {
  const subs = getSubcategories(categories, parentSlug);
  return [parentSlug, ...subs.map((s) => s.slug)];
}
